import React from 'react'
import { CellRenderer } from '../../legacy-design-system/grid'
import { Route } from '../../graphql/schema/types/route'
import { FormattedDate, FormattedRelativeTime, FormattedTime } from 'react-intl'
import { WithTooltip } from '../../design-system'
import { selectRelativeUnits } from '../react-intl-helpers'
import { css } from '@emotion/css'
import { readOnlyGridCss } from '../../legacy-design-system/text'

const cellCss = css`
  padding: 10px;
  text-align: left;
`

export function getLastActivityCellRenderer(): CellRenderer<Route> {
  return function lastActivitiesCellRenderer({
    rowData: { exercised },
    getCellContentProps
  }) {
    // eslint-disable-next-line eqeqeq
    if (exercised != undefined) {
      const { value, unit } = selectRelativeUnits(exercised)
      return (
        <WithTooltip
          tiny={true}
          renderTooltipContent={() => (
            <FormattedDate value={exercised}>
              {(dateText) => (
                <FormattedTime value={exercised}>
                  {(timeText) => <span children={`${dateText} ${timeText}`} />}
                </FormattedTime>
              )}
            </FormattedDate>
          )}
          children={() => (
            <div {...getCellContentProps({ className: cellCss })}>
              <FormattedRelativeTime value={value} unit={unit} numeric="auto">
                {(text) => <span className={readOnlyGridCss} children={text} />}
              </FormattedRelativeTime>
            </div>
          )}
        />
      )
    } else {
      return (
        <div {...getCellContentProps({ className: cellCss })}>
          <span className={readOnlyGridCss} children={'-'} />
        </div>
      )
    }
  }
}
